/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KinnserDocumentUploadAllOfLatestUpload
 */
export interface KinnserDocumentUploadAllOfLatestUpload {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    status: KinnserDocumentUploadAllOfLatestUploadStatusEnum;
    /**
     * 
     */
    submitted_at: string;
    /**
     * 
     */
    error_message: string;
    /**
     * 
     */
    response: { [key: string]: any; };
}


/**
 * @export
 */
export const KinnserDocumentUploadAllOfLatestUploadStatusEnum = {
    Pending: 'pending',
    InProgress: 'in_progress',
    Succeeded: 'succeeded',
    Failed: 'failed',
} as const;
export type KinnserDocumentUploadAllOfLatestUploadStatusEnum = typeof KinnserDocumentUploadAllOfLatestUploadStatusEnum[keyof typeof KinnserDocumentUploadAllOfLatestUploadStatusEnum];


/**
 * Check if a given object implements the KinnserDocumentUploadAllOfLatestUpload interface.
 */
export function instanceOfKinnserDocumentUploadAllOfLatestUpload(value: object): value is KinnserDocumentUploadAllOfLatestUpload {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('submitted_at' in value) || value['submitted_at'] === undefined) return false;
    if (!('error_message' in value) || value['error_message'] === undefined) return false;
    if (!('response' in value) || value['response'] === undefined) return false;
    return true;
}

export function KinnserDocumentUploadAllOfLatestUploadFromJSON(json: any): KinnserDocumentUploadAllOfLatestUpload {
    return KinnserDocumentUploadAllOfLatestUploadFromJSONTyped(json, false);
}

export function KinnserDocumentUploadAllOfLatestUploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserDocumentUploadAllOfLatestUpload {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'submitted_at': json['submitted_at'],
        'error_message': json['error_message'],
        'response': json['response'],
    };
}

export function KinnserDocumentUploadAllOfLatestUploadToJSON(json: any): KinnserDocumentUploadAllOfLatestUpload {
    return KinnserDocumentUploadAllOfLatestUploadToJSONTyped(json, false);
}

export function KinnserDocumentUploadAllOfLatestUploadToJSONTyped(value?: KinnserDocumentUploadAllOfLatestUpload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'submitted_at': value['submitted_at'],
        'error_message': value['error_message'],
        'response': value['response'],
    };
}

